import http from "@/axiosConfig";
import toast from "@/global/ToastConfig";

const bathroomsRoute = {
    LIST_INVOICE: "/reports/overview-report/invoiceBathrooms/list",
    DOWNLOAD_INVOICE_BATHROOMS: "/reports/overview-report/invoiceBathrooms",
    LIST_COLLECTION_BATHROOMS: "/reports/overview-report/collectionBathrooms/list",
    DOWNLOAD_COLLECTION_BATHROOMS:"/reports/overview-report/collectionBathrooms"
}
export default {
    listInvoiceBathrooms(objParams) {
        return new Promise(resolve => {
            let newData = {};
            http.get(bathroomsRoute.LIST_INVOICE, {
                params: objParams
            }).then(({data}) => {
                const code = data.code;
                if (code < 0) {
                    toast.error(data.message);
                    newData = data;
                    return;
                }
                if (!data.info.records || data.info.records.length === 0) {
                    toast.info("No se encontro información con los criterios ingresados");
                    newData = data;
                    return;
                }
                newData = data;
            }).catch(() => toast.error("Error al consultar recaudo"))
                .finally(() => resolve(newData));
        });
    },
    downloadInvoiceBathrooms(objParams) {
        return new Promise(resolve => {
            let newData = {code: -1};
            http.get(bathroomsRoute.DOWNLOAD_INVOICE_BATHROOMS, {
                params: objParams
            }).then(({data}) => {
                const code = data.code;
                if (code < 0) {
                    toast.error(data.message);
                    return;
                }
                newData = data;
            }).catch(() => toast.error("No se pudo realizar la conexión con el servidor"))
                .finally(() => resolve(newData));
        });

    },
    listCollectionBathrooms(objParams) {
        return new Promise(resolve => {
            let newData = {};
            http.get(bathroomsRoute.LIST_COLLECTION_BATHROOMS, {
                params: objParams
            }).then(({data}) => {
                const code = data.code;
                if (code < 0) {
                    toast.error(data.message);
                    newData = data;
                    return;
                }
                if (!data.info.records || data.info.records.length === 0) {
                    toast.info("No se encontro información con los criterios ingresados");
                    newData = data;
                    return;
                }
                newData = data;
            }).catch(() => toast.error("Error al consultar consolidado del recaudo"))
                .finally(() => resolve(newData));
        });
    },
    downloadCollectionBathrooms(objParams) {
        return new Promise(resolve => {
            let newData = {code: -1};
            http.get(bathroomsRoute.DOWNLOAD_COLLECTION_BATHROOMS, {
                params: objParams
            }).then(({data}) => {
                const code = data.code;
                if (code < 0) {
                    toast.error(data.message);
                    return;
                }
                newData = data;
            }).catch(() => toast.error("No se pudo realizar la conexión con el servidor"))
                .finally(() => resolve(newData));
        });

    },
}